export default {
  tagline: 'A platform for building your digital team',
  heroTag: 'Digital Team AI for human-agent workflows',
  heroTitle: 'Build your digital team\naround your business processes',
  heroSubtitle:
    'Connect your company tools. Discover where AI can create value.',
  heroSubtitle2: 'Build human-controlled agents and measure the impact.',
  heroGraphSource: 'Source',
  heroGraphTicket: 'Ticket',
  heroGraphComments: 'Comments',
  heroGraphSprint: 'Sprint',
  heroGraphStatus: 'Status',
  heroGraphBacklog: 'Backlog',
  heroGraphBugReport: 'Bug report',
  heroGraphRelease: 'Release',
  heroGraphDocs: 'Docs',
  heroGraphSpec: 'Spec',
  heroGraphDecision: 'Decision',
  heroGraphRequirements: 'Requirements',
  heroGraphApiDocs: 'API docs',
  heroGraphChangelog: 'Changelog',
  heroGraphMeetingNotes: 'Meeting notes',
  heroGraphRunbook: 'Runbook',
  heroGraphContext: 'Context',
  heroGraphInterface: 'Interface',
  heroGraphChat: 'Chat',
  heroGraphConversationMemory: 'Conversation memory',
  heroGraphQuestion: 'Question',
  heroGraphThread: 'LTM',
  heroGraphOutput: 'Output',
  heroGraphAnswer: 'Answer',
  heroGraphSources: 'Sources',
  heroGraphRoleContext: 'Role context',
  heroGraphAnswerSources: 'Answer + Sources',
  heroGraphJiraContext: 'Jira context',
  heroGraphDocsContext: 'Docs context',
  heroGraphLaplaceContext: 'Chat context',
  heroGraphSprintScope: 'Sprint scope',
  heroGraphTaskStatus: 'Task status',
  heroGraphBacklogItem: 'Backlog item',
  heroGraphCustomerFeedback: 'Customer feedback',
  heroGraphReleaseWork: 'Release work',
  heroGraphBusinessRequirements: 'Business requirements',
  heroGraphTechnicalDocs: 'Technical docs',
  heroGraphChangeHistory: 'Change history',
  heroGraphDiscussionNotes: 'Discussion notes',
  heroGraphUserAsks: 'User asks',
  heroGraphPrivateThread: 'LTM',
  heroGraphSourceTrace: 'Source trace',
  heroGraphRoleLanguage: 'Role language',
  heroGraphConfluencePages: 'Pages',
  heroGraphConfluenceStrategy: 'Strategy',
  heroGraphConfluenceDocuments: 'Documents',
  heroGraphGithubPullRequests: 'Pull requests',
  heroGraphGithubCommits: 'Commits',
  heroGraphGithubReleases: 'Releases',
  heroGraphMailThreads: 'Threads',
  heroGraphMailInbox: 'Inbox',
  heroGraphMailFeedback: 'Feedback',
  createWorkspace: 'Try Laplace',
  requestDemo: 'Request a demo',
  howItWorks: 'How it works',
  navTop: 'Laplace',
  navIdea: 'Digital team',
  navSavings: 'Audit',
  navSolution: 'Product model',
  navResult: 'Measure',
  navDiscover: 'Audit',
  navBuild: 'Product',
  navMeasure: 'Build',
  navAudience: 'For whom',
  navControl: 'Delivery',
  navSecurity: 'Security',
  navIntegrations: 'Integrations',
  navSolutions: 'Solutions',
  navPricing: 'Pricing',
  navResources: 'Resources',
  login: 'Login',
  openMenu: 'Open menu',

  // Idea section
  ideaEyebrow: 'Product',
  ideaTitle: 'Digital employee',
  ideaBody:
    'Bring teams, agents and systems together to collaborate in one place.',
  buildHeadlineProjectManager: 'Project Manager',
  buildHeadlineContentMaker: 'Content Maker',
  buildHeadlineSupport: 'Support',
  buildHeadlineGtmOps: 'GTM Ops',
  buildScreenshotAlt:
    'Laplace Dev Team workspace showing a release readiness analysis using Jira, Confluence and GitHub data',
  teamLabel: 'Team',
  teamProductOwnerTitle: 'Releases',
  teamProductOwnerName: 'Release Agent',
  teamProductOwnerBody:
    'Build a release and sprint view, explain risks and prepare the next step from tasks, comments and documents.',
  teamProductOwnerOutcome: 'Release context',
  teamProductOwnerSourceTasks: 'Tasks',
  teamProductOwnerSourceComments: 'Comments',
  teamProductOwnerSourceDocs: 'Docs',
  teamProductOwnerSourceStatuses: 'Statuses',
  teamProductOwnerPrompt: 'Why did we choose PostgreSQL over MongoDB?',
  teamProductOwnerAnswer:
    'The decision is recorded in MYT-85: PostgreSQL was chosen for predictable release timelines. Affects the Q3 roadmap.\n\nSource: Jira.',
  teamProductOwnerFeature1Title: 'A defined role',
  teamProductOwnerFeature1Body:
    'The agent owns a specific workflow and outcome instead of acting as a generic assistant for everything.',
  teamProductOwnerFeature2Title: 'Authorized context',
  teamProductOwnerFeature2Body:
    'It uses only connected sources and tools available in the current workspace.',
  teamProductOwnerFeature3Title: 'Human control',
  teamProductOwnerFeature3Body:
    'It prepares decisions and performs write actions only within allowed boundaries.',
  teamAnalystTitle: 'Requirements',
  teamAnalystName: 'Requirements Agent',
  teamAnalystBody:
    'Find requirements, connect them to implementation and surface gaps before they turn into rework.',
  teamAnalystOutcome: 'Requirements to implementation',
  teamAnalystSourceRequirements: 'Requirements',
  teamAnalystSourceDocs: 'Docs',
  teamAnalystSourceComments: 'Comments',
  teamAnalystPrompt: 'Why did we choose PostgreSQL over MongoDB?',
  teamAnalystAnswer:
    'The relational model simplifies reporting and data reconciliation. No MongoDB migration required.\n\nSource: Confluence.',
  teamAnalystFeature1Title: 'Where the solution lives',
  teamAnalystFeature1Body:
    'Locate technical decisions in tickets, chats, and documents even when nobody remembers where they were written.',
  teamAnalystFeature2Title: 'Requirement coverage',
  teamAnalystFeature2Body:
    'Show which requirements are covered by the implementation and where gaps or open questions remain.',
  teamAnalystFeature3Title: 'Translate technical notes',
  teamAnalystFeature3Body:
    'Turn engineering language into business logic, user scenarios, and acceptance criteria.',
  teamEngineersTitle: 'Engineering',
  teamEngineersName: 'Engineering Agent',
  teamEngineersBody:
    'Collect technical task context, dependencies and acceptance criteria and help complete the next authorized step.',
  teamEngineersOutcome: 'Clear task context',
  teamEngineersSourceTasks: 'Tasks',
  teamEngineersSourceDescription: 'Description',
  teamEngineersSourceDocs: 'Docs',
  teamEngineersPrompt: 'Why did we choose PostgreSQL over MongoDB?',
  teamEngineersAnswer:
    'Schema and constraints live in the database. Lower drift risk than with a document model.\n\nSource: GitHub, Confluence.',
  teamEngineersFeature1Title: 'Where requirements are',
  teamEngineersFeature1Body:
    'Find the spec, file, comment, or discussion where the analyst described expected behavior.',
  teamEngineersFeature2Title: 'What is expected',
  teamEngineersFeature2Body:
    'Translate requirements into implementation language: scenarios, constraints, edge cases, and acceptance criteria.',
  teamEngineersFeature3Title: 'Preserve decisions',
  teamEngineersFeature3Body:
    'Attach technical decisions to the task so product and analysts can find and understand them later.',
  teamSupportTitle: 'Support',
  teamSupportName: 'Support Agent',
  teamSupportBody:
    'Connect customer feedback to tasks, statuses and decisions and prepare a consistent customer response.',
  teamSupportOutcome: 'Feedback status',
  teamSupportSourceDocs: 'Docs',
  teamSupportSourceTasks: 'Tasks',
  teamSupportSourceDescription: 'Description',
  teamSupportPrompt: 'Why did we choose PostgreSQL over MongoDB?',
  teamSupportAnswer:
    'There was a customer request about migration timing and possible support impact. The changes are internal at the infrastructure level, so SLAs and customer response timelines do not change.\n\nSource: Confluence.',
  teamSupportFeature1Title: 'Is there a Jira task?',
  teamSupportFeature1Body:
    'Check whether a customer issue already has a task, who owns it, and what status it is in.',
  teamSupportFeature2Title: 'What was already said',
  teamSupportFeature2Body:
    'Recover previous replies, related discussions, and decisions so the customer answer stays consistent.',
  teamSupportFeature3Title: 'Team escalation brief',
  teamSupportFeature3Body:
    'Package customer feedback, linked tasks, and discussion history into a clear request for product or engineering.',
  teamHowItWorks: 'How it works',
  teamSources: 'Connected sources',
  teamOutcome: 'Outcome',
  teamVisualRequest: 'Current focus',
  teamVisualContext: 'Context:',
  teamVisualSendLabel: 'Send',
  teamVisualTry: 'Try it',
  teamVisualTryHint: 'send the question',
  result: 'Result',
  unifiedContext: 'The information exists, but it is scattered and gets lost',
  unifiedContextBody:
    'The team repeatedly searches tickets, reads discussions, checks documents, and asks the people who remember the context.',

  // Savings section
  savingsEyebrow: 'Audit',
  savingsTitle: 'Find the process where AI can create the most value',
  savingsBody:
    'Context Audit turns a broad AI ambition into one concrete, bounded and measurable use case.',
  auditScreenshotAlt:
    'Context Audit interface with a context debt score, trend chart and connected-system metrics',
  valueItem1Title: 'See where work slows down',
  valueItem1Body:
    'Inspect tasks, documents, code changes, decisions and meetings to find manual search and coordination costs.',
  valueItem2Title: 'Capture the starting point',
  valueItem2Body:
    'Get a versioned report, source coverage, object drill-down and a lost-hours range with transparent assumptions.',
  valueItem3Title: 'Choose the first pilot',
  valueItem3Body:
    'Prioritize one repeatable workflow and define its owner and success criteria before deploying an agent.',
  workspaceVisualProduct: 'Dev team',
  workspaceVisualSupport: 'Your support workspace',
  workspaceVisualAnalytics: 'Your analytics workspace',
  workspaceVisualCurrent: 'Current workspace',
  workspaceVisualAccessScoped: 'Scoped access',
  workspaceVisualPlugins: 'Connected plugins',
  workspaceVisualJiraScope: 'Tasks, comments, statuses, and team decisions.',
  workspaceVisualDocsScope: 'Specs, requirements, guides, and release notes.',
  workspaceVisualPermissions: 'User permissions',
  workspaceVisualPermissionsBody:
    'Even inside a workspace, users only see the information they can access in the original systems.',
  workspaceVisualAllowedTask: 'Jira: MYT-12',
  workspaceVisualAllowedDoc: 'Docs: Checkout Scope v2',
  workspaceVisualHiddenChannel: 'Docs: Finance plan',

  // How it works section
  howItWorksTitle: 'Move from AI ambition to a working process',
  howItWorksBody:
    'Laplace connects audits, agents, tools and automations in a repeatable cycle around real company work.',
  cycleDiscoverTitle: 'Audit',
  cycleDiscoverBody:
    'Inspect work context, find repetitive work and select a process with a clear opportunity.',
  cycleBuildTitle: 'Build',
  cycleBuildBody:
    'Create an agent with a role, context, tools, a schedule and clear human-control boundaries.',
  cycleMeasureTitle: 'Measure',
  cycleMeasureBody:
    'Compare the pilot with its starting point, improve the workflow and identify the next opportunity.',

  // Result section
  resultEyebrow: 'Build',
  resultTitle: 'Hundreds of digital employees under one subscription.',
  resultBody:
    'Create a digital employee and automate routine tasks so you can spend more time on higher-value work.',
  resultScreenshotAlt:
    'Laplace agent management screen showing digital employees, tools, tags and update dates',
  resultAccordionTitle1: 'Roles built around your processes',
  resultAccordionBody1:
    'Create digital employees for project management, support, content, sales and any internal process.',
  resultAccordionTitle2:
    'Audit provides recommendations for optimizing your processes',
  resultAccordionBody2:
    'Based on the Context Audit, Laplace shows which processes to fix, optimize and automate first.',
  resultAccordionTitle3: 'Routine task automation',
  resultAccordionBody3:
    'Run automations on a schedule. Digital employees handle repeatable operations and escalate exceptions to people.',
  question: 'Question',
  questionText:
    'Who is responsible for the migration plan and why did we postpone the release?',
  answerLabel: "Laplace's answer",
  answerText:
    'Alex is responsible for the migration plan. The release was postponed because the team identified a data schema risk and decided to complete migrations first.',
  answerContext:
    'Who, what, why, and for what purpose: an answer to any question about the task.',
  resultContextItemDiscussions: 'Discussions',
  resultContextItemReasons: 'Reasons',
  resultContextItemHistory: 'Change history',
  resultContextItemParticipants: 'Participants',
  // Audiences section
  audiencesEyebrow: 'Two entry points',
  audiencesTitle: 'One platform, different starting points',
  audiencesBody:
    'Laplace helps companies start their AI journey or strengthen an established enterprise AI team.',
  audienceGrowingEyebrow: 'For growing companies',
  audienceGrowingTitle:
    'Create virtual employees around your company processes',
  audienceGrowingBody:
    'Start with one virtual employee, connect the required systems and expand your digital team as the workload grows.',
  audienceEnterpriseEyebrow: 'For enterprise AI teams',
  audienceEnterpriseTitle: 'Audit, prioritize and measure AI initiatives',
  audienceEnterpriseBody:
    'Find the next opportunities, establish a baseline and governance. Build with Laplace, your own stack or both.',

  // End-to-end delivery section
  controlEyebrow: 'End-to-end digitization',
  controlTitle: 'We help digitize your processes from start to finish',
  controlBody:
    'Our clients always come first. We build plugins around your processes and accommodate your requirements.',
  controlStep1Title: 'Understand your processes',
  controlStep1Body:
    'We learn how your team works, identify digitization opportunities and agree on rollout priorities together.',
  controlStep2Title: 'Build the right solution',
  controlStep2Body:
    'We create the required plugins, connect your systems and configure digital employees around your processes.',
  controlStep3Title: 'Launch and keep improving',
  controlStep3Body:
    'We support the rollout, gather feedback and evolve the solution as your business changes.',
  controlSupportTitle: 'We stay involved after launch',
  controlSupportBody:
    'We incorporate new requests, improve integrations and help expand digitization to the next processes.',
  controlDeploymentLabel: 'Delivered in your environment',
  deploymentCloudTitle: 'Cloud',
  deploymentHybridTitle: 'Hybrid',
  deploymentOnPremTitle: 'On-Premises',

  // Demo card
  demoTag: 'Demo Scenario',
  demoTitle: 'Ask once. Get clarity',
  demoDescription:
    'Laplace gives a human answer from all the knowledge gathered by your team, with sources cited.',
  userAsks: 'User asks',
  demoQuestion: 'Why is the client launch delayed?',
  laplaceAnswers: 'Laplace answers',
  demoAnswer:
    'The launch is delayed by two blockers: LAP-124 for SSO is still open and the access checklist for the client team has not been approved. Alex owns the next step - final security confirmation. Sources: Jira, Confluence',

  // CTA
  ctaTitle: 'Laplace knows everything',
  ctaSubtitle: 'The tool everyone needs.',
  notFoundEyebrow: 'Page not found',
  notFoundTitle: 'This route does not lead to any known context.',
  notFoundShort: 'Ooops. Nothing to see here.',
  notFoundBody:
    'The link may be outdated, the address may have been entered incorrectly, or the page may have been moved. Return to the landing page or sign in to continue into your workspace.',
  notFoundBackHome: 'Back home',
}
